import violationDetail from '../components/violationDetail.vue'

export default {
  data() {
    return {
      detailSource: {},
    }
  },
  components: { violationDetail },
  methods: {
    // 点击Id展示详情
    detail(data) {
      this.detailSource = { ...data }
      this.$refs.violationDetailRef.isShow = true
    },
  },
}
